import { request } from './cart-service.js';

// Cart state manager: tracks in-cart quantities per variant and exposes helpers
(() => {

  const U = window.umbrellaConfig = window.umbrellaConfig || {};
  const events = (U && U.events) || {};
  const state = { variantQty: {}, lastSyncedAt: 0 };

  function emitCartState(cart){
    const detail = { cart, state };
    const names = new Set();
    if(events.cartChange) names.add(events.cartChange);
    // Always emit the canonical default for compatibility
    names.add('cart:state');
    names.forEach((name) => {
      document.dispatchEvent(new CustomEvent(name, {
        detail,
        bubbles: true,
        composed: true
      }));
    });
  };

  function computeFromCart(cart){
    const map = {};
    if(cart && Array.isArray(cart.items)){
      for(const it of cart.items){
        const vid = it.variant_id;
        const qty = it.quantity || 0;
        if(vid) map[vid] = (map[vid] || 0) + qty;
      };
    };
    state.variantQty = map;
    state.lastSyncedAt = Date.now();
    emitCartState(cart);
  };

  async function syncCart(){
    try {
      const cart = await request('/cart.js');
      computeFromCart(cart);
    } catch(err) {
      console.warn('cart-state: sync failed', err);
    };
  };

  function getInCartQty(variantId) {
    const id = Number(variantId);
    if(Number.isNaN(id)) return 0;
    return state.variantQty[id] || 0;
  };

  U.cartState = state;
  U.getInCartQty = getInCartQty;
  U.syncCart = syncCart;

  // Initial sync
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', () => { syncCart(); })
    : syncCart();

  // Keep in sync on visibility
  document.addEventListener('visibilitychange', () => {
    if(document.visibilityState === 'visible') syncCart();
  });

  // Keep in sync on known cart mutation events
  if(events.cartAdded) document.addEventListener(events.cartAdded, () => { syncCart(); });

  if(events.cartItemUpdated) document.addEventListener(events.cartItemUpdated, () => { syncCart(); });

  if(events.cartItemRemoved) document.addEventListener(events.cartItemRemoved, () => { syncCart(); });

})();